<template>
  <div :class="className">
    <input 
      :id="inputId"
      type="number"
      :class="`${isValid ? 'is-invalid' : ''} form-control`"
      :value="value"
      :step="step"
      :disabled="disabled"
      :readonly="readonly"
      onkeydown="return event.keyCode !== 69"
      @keypress.enter.prevent
      @focusout="validateEntry(this)" />

    <div class="invalid-feedback" v-if="message.length > 0">
      {{message}}
    </div>
  </div>
</template>

<script>
    export default {
        props: [
          'inputId', 
          'name',
          'className',
          'step',
          'value',
          'rules',
          'label',
          'disabled',
          'readonly'
        ],
        data() {
        return {
            message: '',
            isValid: false
          }
        },
        methods: {
          // Forward events to the parent component

          validateEntry() {
            event.preventDefault();
            if (event) {
              let val = event.target.value
              if (val == '') {
                val = 0      
              } else if (val < this.rules.min.value ) {
                this.isValid = true
                this.message = `${this.label} ${this.rules.min.error} ${this.rules.min.value}` 
              } else if (val > this.rules.max.value ) {
                this.isValid = true
                this.message = `${this.label} ${this.rules.max.error} ${this.rules.max.value}` 
              } else {
                this.isValid = false
                this.message = '';
              }
              this.$emit('input', val)
            }

          }
        }
    }
</script>

